module.exports = __webpack_public_path__ + "img/10.78c21b8.png";